export default __webpack_public_path__ + "static/media/main.73232809.jpg";